import { apiClient } from './client';
import type { TokenResponse } from '@/types/api';

export interface PublicBranch {
  id: number;
  name: string;
  address: string | null;
  phone: string | null;
  latitude: number | null;
  longitude: number | null;
  working_hours: Record<string, { open: string; close: string } | null> | null;
}

export interface CustomerRegistrationData {
  email: string;
  password: string;
  full_name: string;
  phone?: string;
  atomi_id: number;
  branch_id?: number;
}

export interface BranchApplicationData {
  applicant_name: string;
  applicant_email: string;
  applicant_phone?: string;
  password: string;
  branch_name: string;
  branch_address: string;
  branch_phone?: string;
  latitude?: number;
  longitude?: number;
  working_hours?: Record<string, { open: string; close: string } | null>;
}

export const registrationApi = {
  getPublicBranches: async (): Promise<PublicBranch[]> => {
    const response = await apiClient.get<PublicBranch[]>('/v1/registration/branches');
    return response.data;
  },

  registerCustomer: async (data: CustomerRegistrationData): Promise<TokenResponse> => {
    const response = await apiClient.post<TokenResponse>('/v1/registration/customer', data);
    return response.data;
  },

  registerBranch: async (data: BranchApplicationData): Promise<{ id: number }> => {
    const response = await apiClient.post<{ id: number }>('/v1/registration/branch-application', data);
    return response.data;
  },
};
